import { memo, useCallback } from "react";
import useSearchInvoiceService from "../../../../../helper/services/searchInvoiceServices"
import { SearchSingleFunction } from "../../../../../model/searchInvoiceModels";
import SearchSingleForm from "../../../../UI/Search/Single/SearchSingleForm"

const Invoice: React.FC = () => {
    const searchInvoiceService = useSearchInvoiceService();

    const searchSingleInvoiceFunction: SearchSingleFunction = useCallback((taxCode, securityCode) => {
        return searchInvoiceService.getPdfInvoice(taxCode, securityCode, false);
    }, [])
    return <SearchSingleForm
        header="hóa đơn điện tử"
        searchInvoice={searchSingleInvoiceFunction}
    />
}
export default memo(Invoice);